export const posters = [
  {
    id: 0,
    title: "Reactflix Movies App",
    content: "React JS, MUI, Alan AI, Redux Toolkit Query",
    image: "/poster-image/reactMovies.png",
    liveUrl: "https://reactflix-cwr.netlify.app/",
    codeUrl:
      "https://github.com/crisner1978/react_movies_app",
  },
  {
    id: 1,
    title: "Next JS E-Commerce",
    content: "React JS, TypeScript, MongoDB, TailwindCSS",
    image: "/poster-image/furnitureBarn.png",
    liveUrl: "https://next-commerce-chi-five.vercel.app/",
    codeUrl: "https://github.com/crisner1978/next-commerce",
  },
  {
    id: 2,
    title: "Tiktok Clone",
    content: "React JS, Firebase, React-Firebase Hooks, Draft JS",
    image: "/poster-image/tiktokReact.png",
    liveUrl: "https://tiktok-clone-cr.web.app/",
    codeUrl: "https://github.com/crisner1978/tiktok-clone-fb2",
  },
  {
    id: 3,
    title: "Blugenix INC",
    content: "Next JS, TypeScript, GraphCMS & Tailwind",
    image: "/poster-image/blugenix.png",
    liveUrl: "https://blugenix-blog.vercel.app/",
    codeUrl: "https://github.com/crisner1978/blugenix-blog",
  },
  {
    id: 4,
    title: "Next JS Twitter Clone",
    content: "React JS, TypeScript, Sanity & Tailwind",
    image: "/poster-image/nextjs-twitter.png",
    liveUrl: "https://twitter-nextjs-two.vercel.app/",
    codeUrl: "https://github.com/crisner1978/twitter-nextjs",
  },
  {
    id: 5,
    title: "Next JS Medium Clone",
    content: "React JS, TypeScript, Sanity & Tailwind",
    image: "/poster-image/mdsanityio.png",
    liveUrl: "https://md-sanityio-app.vercel.app/",
    codeUrl: "https://github.com/crisner1978/md-sanityio-app",
  },
  {
    id: 6,
    title: "NFT Mint Drop",
    content: "Next JS, TypeScript, Sanity & Tailwind",
    image: "/poster-image/nftmintdrop.png",
    liveUrl: "https://nftmint-drop.vercel.app/",
    codeUrl: "https://github.com/crisner1978/nftmint-drop",
  },
  {
    id: 7,
    title: "Snow Legend Malamute",
    content: "Next JS/React, Sendgrid & Tailwind",
    image: "/poster-image/malamutes.png",
    liveUrl: "https://www.snowlegendmalamutes.com/",
    codeUrl: "https://github.com/crisner1978/malamutes",
  },
  {
    id: 8,
    title: "Therapeutic Hair & Scalp",
    content: "Next JS/React, MongoDB, Next-Auth & Tailwind",
    image: "/poster-image/therapeuticSalon.png",
    liveUrl: "https://therapeutic-hair-salon.vercel.app/",
    codeUrl: "https://github.com/crisner1978/therapeutic-hair-salon",
  },
  {
    id: 9,
    title: "Reddit Clone Project",
    content: "React JS, Firebase v9 Auth/Firestore & Zustand",
    image: "/poster-image/Reddit clone.png",
    liveUrl: "https://reddit-clone-rise.web.app/",
    codeUrl: "https://github.com/crisner1978/reddit-project",
  },
  {
    id: 10,
    title: "Airbnb Clone Project",
    content: "Next JS/React App with MongoDB & Tailwind",
    image: "/poster-image/airbnb-clone.png",
    liveUrl: "https://airbnb-mongodb-app.vercel.app/",
    codeUrl: "https://github.com/crisner1978/airbnb-mongodb-app",
  },
  {
    id: 11,
    title: "E-Commerce React",
    content: "React & Node JS, Use Shopping Cart & Stripe",
    image: "/poster-image/ecomReact.png",
    liveUrl: "https://e-comm-reactjs.herokuapp.com/",
    codeUrl: "https://github.com/crisner1978/e-commerce-mern",
  },
];
